<template>
  <el-form-item :label="title">
    <el-select
      v-model="value"
      remote
      :placeholder="placeholder"
      :loading="loading"
      :disabled="disabled"
      :style="{width: width + 'px'}"
      :class="itemClass"
    >
      <el-option v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { parse, save } from '../providers/store-parser'

export default {
  name: 'InputSelectRemoteSuggestion',
  data () {
    return {
      options: [],
      loading: false
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    query: {
      type: Function,
      required: true
    },
    getter: {
      type: String,
      required: true
    },
    setter: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    isRequire: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 140
    },
    itemClass: {
      type: String,
      default: ''
    }
  },
  created () {
    this.handleQuery()
  },
  computed: {
    value: {
      get () {
        return parse(this.getter)
      },
      set (val) {
        // const item = this.options.find(o => o.value == val).data || {}
        save(this.setter, val)
        this.$emit('select-chagned', val)
      }
    }
  },
  methods: {
    async handleQuery () {
      this.loading = true
      this.options = await this.query()
      this.loading = false
    }
  }
}
</script>
